import { render } from "./LandlordLayout.vue?vue&type=template&id=4636cd7e"
import script from "./LandlordLayout.vue?vue&type=script&lang=js"
export * from "./LandlordLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__